import Typography from "@portal/components/atoms/v2/typography";
import { RobotTextResources } from "@portal/assets/text/RobotTextResources";
import { SelectionBoxComponent } from "../../../components/selectionBox/SelectionBoxComponent";
import { useState } from "react";
import { useRobot } from "@portal/app/context/robotProvider";
import { GetOption } from "../../../sustainability/common/helpers/getOption";
import { ChevronCircleButton } from "@portal/components/atoms/buttons/chevronCircle/ChevronCircleButton";
import PortalPageBox from "@portal/components/atoms/portalPageBox";
import { ISustainabilityProps } from "../../../sustainability/common/types";

export const PAIInfo = ({ isDefaultLanguage }: ISustainabilityProps) => {
  const { riskLevelRequest, setSustainabilityPai } = useRobot();
  const [isExpanded, setIsExpanded] = useState(false);
  const texts = isDefaultLanguage ? RobotTextResources.primary : RobotTextResources.secondary;
  const options = [texts.PAGE_7_OPTIONS_3_A, texts.PAGE_7_OPTIONS_3_B];
  const OnSelectionClick = (selectedOption: number) => {
    if (selectedOption !== null) {
      setSustainabilityPai(selectedOption === 0);
    }
  };
  return (
    <div className="flex flex-col sm:flex-row sm:space-x-3">
      <PortalPageBox className="flex flex-col my-3 sm:w-[60%]">
        <Typography variant="Lead">{texts.PAGE_7_INFO_TEXT_3_HEADER}</Typography>
        <Typography variant="Body">{texts.PAGE_7_INFO_TEXT_3_A}</Typography>
        <div className="flex py-2 justify-center">
          <ChevronCircleButton isExpanded={isExpanded} setIsExpanded={setIsExpanded} />
        </div>
        {isExpanded && <Typography variant="Body">{texts.PAGE_7_INFO_TEXT_3_B}</Typography>}
      </PortalPageBox>
      <div className="flex sm:w-[40%] w-full">
        <SelectionBoxComponent
          options={options}
          selectedOption={GetOption(riskLevelRequest.sustainabilityPai) ?? -1}
          onSelectionClick={OnSelectionClick}
        />
      </div>
    </div>
  );
};
